var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealtimeData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location_video_01",
    transform: "translate(-262.000000, -31.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3844450_cloud_computing_data_server_upload_icon",
    transform: "translate(263.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7, 7) scale(0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2537143,9.97052632 C25.8377143,4.3993985 21.3977143,0 16,0 C11.3828571,0 7.41942857,3.15669173 6.14057143,7.7606015 C2.49257143,9.09353383 0,12.7314286 0,16.8421053 C0,22.1485714 4.10171429,26.4661654 9.14285714,26.4661654 L24,26.4661654 C28.4114286,26.4661654 32,22.6887218 32,18.0451128 C32,14.2568421 29.6342857,11.0051128 26.2537143,9.97052632 Z",
    id: "XMLID_270_",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,9 C16.5522847,9 17,9.44771525 17,10 L17,18 L17,18 L15,18 L15,10 C15,9.44771525 15.4477153,9 16,9 Z",
    id: "Rectangle",
    stroke: "#000000",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,16 L20,16 C20.5522847,16 21,16.4477153 21,17 C21,17.5522847 20.5522847,18 20,18 L17,18 L17,18 L17,16 Z",
    id: "Rectangle",
    stroke: "#000000",
    fill: "black"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtimeData);
export default __webpack_public_path__ + "static/media/realtime-data.e6efa53808deddb1e22d255664b681ce.svg";
export { ForwardRef as ReactComponent };